import React from 'react';
import { StudentViewCard } from './StudentViewCard';
import { StudentCreateForm, StudentFormRow, StudentRowErrors } from './StudentCreateForm';
import { Student } from './StudentListItem';
import type { Program, ProgramAssignment } from '../ProgramsManager';

export type { StudentFormRow, StudentRowErrors };

export interface StudentFormProps {
  mode: 'view' | 'create';
  student?: Student | null;
  createRows: StudentFormRow[];
  createErrors: Record<string, StudentRowErrors>;
  onRowChange: (rowId: string, field: 'full_name' | 'email', value: string) => void;
  onAddRow: () => void;
  onRemoveRow: (rowId: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onClose: () => void;
  programs?: ProgramAssignment[];
  availablePrograms?: Program[];
  onProgramAdd?: (programId: string) => void;
  onProgramRemove?: (programId: string) => void;
  onProgramDateChange?: (
    programId: string,
    field: 'theoretical_start_date' | 'theoretical_end_date' | 'exam_date',
    date: Date | null
  ) => void;
  onStudentChange?: (studentId: string, field: 'full_name' | 'email', value: string) => void;
  viewErrors?: { email?: string };
}

export const StudentForm: React.FC<StudentFormProps> = ({
  mode,
  student,
  createRows,
  createErrors,
  onRowChange,
  onAddRow,
  onRemoveRow,
  onSubmit,
  onClose,
  programs = [],
  availablePrograms = [],
  onProgramAdd,
  onProgramRemove,
  onProgramDateChange,
  onStudentChange,
  viewErrors = {},
}) => {
  if (mode === 'view' && student) {
    return (
      <StudentViewCard
        student={student}
        onClose={onClose}
        programs={programs}
        availablePrograms={availablePrograms}
        onProgramAdd={onProgramAdd}
        onProgramRemove={onProgramRemove}
        onProgramDateChange={onProgramDateChange}
        onStudentChange={onStudentChange}
        errors={viewErrors}
      />
    );
  }

  return (
    <StudentCreateForm
      rows={createRows}
      errors={createErrors}
      onRowChange={onRowChange}
      onAddRow={onAddRow}
      onRemoveRow={onRemoveRow}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  );
};